import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CardList from "./ui/CardList";
import { Api, DealDto } from "../../shared/swagger/client/api-client";
import { VDP } from "../VDP";

const apiUrl = process.env.REACT_APP_OFFER_CHAT_API_URL || 'http://localhost:3000';

export const HomePage = () => {
  const [searchParams] = useSearchParams();
  const initType = searchParams.get('init');
  const clientId = searchParams.get('client') || 'dupont-client';
  const [deals, setDeals] = useState<DealDto[]>([]);
  const [selectedDeal, setSelectedDeal] = useState<DealDto>();
  const vdpRef = useRef(null);

  const theme = {
    widget: {
      background: '#1a1a33',
      border: '3px solid red',
      borderRadius: '10px',
    },
    button: {
      primary: {
        background: 'red',
        color: 'white',
        border: '3px solid red',
        borderRadius: '10px',
        hover: {
          background: 'yellow',
          color: 'black',
          border: '10px solid blue',
        },
      },
      secondary: {  
        background: 'blue',
        hover: {
          background: 'green',
          color: 'red',
          border: '3px solid red',
        },
        color: 'white',
        border: '1px solid violet',
        borderRadius: '10px',
      },
    },
  };
  
  const byuerInit = useMemo(() => ({
    bearerToken: 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIxMSIsImVtYWlsIjoiYnV5ZXIxMUBkdXBvbnRyZWdlc3RyeS5jb20iLCJmaXJzdE5hbWUiOiJQYWJsbyIsImxhc3ROYW1lIjoiVXNvdiIsInN0YXRlIjoiRkwiLCJ6aXBDb2RlIjoiMzQ0MDEiLCJwaG9uZSI6IjEyMzQ1Njc4OTAiLCJpYXQiOjE3MzczOTUyODIsImV4cCI6MjAzNzQ2ODg5OX0.64dTrzwFHcfHQx_nU4GTfGYkB5ixmL7nbcTZU0nabRU',
    baseUrl: apiUrl,
    containerDivId: 'offer-chat',
    pageUrl: 'https://testing-new.dupontregistry.com/autos/listing/2022/lamborghini/aventador/29981',
    deal: selectedDeal,
    mode: 'main',
    theme,
    buyNowButtonText: 'Buy Now - TEST Buy Now - TEST Buy Now - TEST',
    buyNowStepMessage: 'New message for buy now',
  }), [selectedDeal]);

  const sellerInit = useMemo(() => ({
    bearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxMCIsImVtYWlsIjoic2VsbGVyQGR1cG9udC5jb20iLCJmaXJzdE5hbWUiOiJKb2huIiwibGFzdE5hbWUiOiJEb2UiLCJzdGF0ZSI6IkZMIiwiemlwQ29kZSI6IjM0NDAxIiwicGhvbmUiOiIxMjM0NTY3ODkwIiwiaWF0IjoxNzM3Mzk1MjgyLCJleHAiOjIwMzc0Njg4OTksInR5cGUiOiJzZWxsZXIifQ.WR_vxp7GiRlOYcBxrWDz9SqnXoQ9MxlbkPNQRLuNPSc',
    // bearerToken: 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIxMSIsImVtYWlsIjoiYnV5ZXIxMUBkdXBvbnRyZWdlc3RyeS5jb20iLCJmaXJzdE5hbWUiOiJQYWJsbyIsImxhc3ROYW1lIjoiVXNvdiIsInN0YXRlIjoiRkwiLCJ6aXBDb2RlIjoiMzQ0MDEiLCJwaG9uZSI6IjEyMzQ1Njc4OTAiLCJpYXQiOjE3MzczOTUyODIsImV4cCI6MjAzNzQ2ODg5OX0.64dTrzwFHcfHQx_nU4GTfGYkB5ixmL7nbcTZU0nabRU',
    baseUrl: apiUrl,
    containerDivId: 'offer-chat',
    containerAdminDivId: 'offer-chat-admin',
    pageUrl: 'https://testing-new.dupontregistry.com/autos/listing/2022/lamborghini/aventador/29981',
    deal: selectedDeal,
    mode: 'main',
    theme,
    buyNowButtonText: 'Buy Now - TEST SELLER',
    buyNowStepMessage: 'New message for buy now',
  }), [selectedDeal]);
  
  const sellerCLient = useMemo(() => {
    return new Api({
      baseUrl: sellerInit.baseUrl,
      baseApiParams: {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${sellerInit.bearerToken}`,
          'x-request-client': clientId || '',
        },
      }
    });
  }, [clientId, sellerInit.bearerToken, sellerInit.baseUrl])

  useEffect(() => {
    if (window.OfferChat) {
      const init = initType === 'seller' ? sellerInit : byuerInit;
      window.OfferChat.init(init);
    }
  }, [byuerInit, initType, selectedDeal, sellerInit]);

  useEffect(() => {
    if (sellerCLient) {
      sellerCLient
        .api
        .dealControllerGetList().then(res => {
          if (res?.data?.data) {
            setDeals(res.data.data);
          }
        })
    }
  }, [sellerCLient]);

  if (selectedDeal) {
    return <VDP ref={vdpRef} data={selectedDeal} initType={initType} />
  }

  return (
    <div>
      <h3 style={{ color: '#136aaf' }}>{initType === 'seller' ? 'Seller' : 'Buyer'}</h3>
      <CardList items={deals} onCardClick={(deal) => setSelectedDeal(deal)}  />
    </div>
  );
};
